<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="panel-container">
    <div class="panel">
      <CircularButton
        class="back-btn"
        icon="long-arrow-alt-left"
        color="var(--light-clr)"
        @click="goBack"
      />
      <div class="business">
        <div class="business-info-panel">
          <div class="business-image">
            <img :src="business.logo" alt="Business' Image" />
          </div>
          <div class="business-info">
            <div class="business-name">
              <h2>{{ business.name }}</h2>
            </div>
            <div class="business-type">
              {{ business.type.replaceAll("_", " ") }}
            </div>
            <div class="business-desc">{{ business.desc }}</div>
            <div class="business-email">
              <span class="label"
                ><fa class="label-icon" icon="at" />Email:</span
              >
              <span class="data"
                ><a :href="'mailto:' + business.contact.email">{{
                  business.contact.email
                }}</a></span
              >
            </div>
            <div class="business-website">
              <span class="label"
                ><fa class="label-icon" icon="globe" />Website:</span
              >
              <span class="data"
                ><a
                  :href="'https://' + business.contact.website"
                  target="_blank"
                  >{{ business.contact.website }}</a
                ></span
              >
            </div>
            <div class="business-tel">
              <span class="label"
                ><fa class="label-icon" icon="phone" />Tel.:</span
              >
              <span class="data"
                ><a :href="'tel:' + business.contact.tel">{{
                  business.contact.tel
                }}</a></span
              >
            </div>
            <div class="business-schedule">
              <span class="label"
                ><fa class="label-icon" icon="calendar-alt" />Schedule:</span
              >
              <span class="data">{{ business.contact.schedule }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
// import Button from "@/components/Button.vue";
import CircularButton from "@/components/CircularButton.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";

// const query = window.location.search;
// const getParameters = new URLSearchParams(query);

let getParameters;

let jwt = localStorage.getItem("jwt");

function validURL(str) {
  var pattern =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return pattern.test(str);
}

function fetchBusinessData(self) {
  if (jwt == null) {
    console.error("No JWT!");
    self.$router.push("/");
  }

  if (getParameters.has("id")) {
    let businessID = getParameters.get("id");

    const headers = {
      Authorization: "Bearer " + jwt,
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/business/${businessID}`, {
        headers: headers,
      })
      .then(function (res) {
        self.business.name = res.data.name;
        self.business.type = res.data.type;
        self.business.desc = res.data.desc;
        self.business.logo = res.data.logo;
        self.business.contact.email = res.data.contact.email;
        self.business.contact.website = res.data.contact.website;
        self.business.contact.tel = res.data.contact.tel;
        self.business.contact.schedule = res.data.contact.schedule;

        let title = `${self.business.name} - Dating4Pets`;
        document.title = title;
        if (validURL(self.business.logo)) {
          console.log(self.business.logo);
        } else {
          axios
            .get(
              `${process.env.VUE_APP_BACKEND}/business/images/${self.business.logo}`,
              {
                headers: headers,
              }
            )
            .then(function () {
              self.business.logo = `${process.env.VUE_APP_BACKEND}/business/images/${self.business.logo}`;
            })
            .catch(() => {
              self.business.logo = "/paw.svg";
            });
        }

        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);
      })
      .catch(function (err) {
        if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          console.error("Unauthorized!");
          self.$router.push("/");
        } else {
          Swal.fire("An error occured", `${err}`, "error").then(() => {
            console.error("Unknown error! " + err);
            self.$router.push("/");
          });
        }
      });
  } else {
    console.error("No ID found!");
    self.$router.push("/");
  }
}

let headers = {};

export default {
  name: "BusinessInfo",
  components: {
    Navbar,
    // Button,
    CircularButton,
    LoadingScreen,
  },
  mounted() {
    let title = "Business Info - Dating4Pets";
    document.title = title;
    let self = this;
    const query = window.location.search;
    getParameters = new URLSearchParams(query);

    this.backend = process.env.VUE_APP_BACKEND;
    fetchBusinessData(self);

    if (localStorage.getItem("jwt") == null) {
      self.$router.push("/");
    }

    headers = {
      Authorization: `Bearer ${jwt}`,
    };

    headers["content-type"] = "application/json";
  },
  data() {
    return {
      business: {
        name: "",
        type: "",
        desc: "",
        logo: "",
        contact: {
          email: "",
          website: "",
          tel: "",
          schedule: "",
        },
      },
      backend: "",
    };
  },
  methods: {
    goBack() {
      let self = this;
      self.$router.go(-1);
    },
  },
};
</script>

<style scoped>
* {
  overflow: visible;
}
.panel-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
  margin-block: 5em;
  width: 100%;
}

.panel {
  min-width: 15em;
  width: 80%;
  max-width: 80em;
  background: var(--light-clr);
  border-radius: 1em;
  box-shadow: var(--light-box-shadow);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2em;

  position: relative;
  /* FOR TESTING */
}

.call-to-action {
  display: flex;
  flex-direction: row;
  /* height: 2em; */
  gap: var(--gap);
  color: var(--light-clr);
  margin-block-start: 2em;
}

.button-text {
  color: var(--light-clr);
}

.business {
  margin: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.business-image {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 0.1rem 2rem hsla(0, 0%, 0%, 0.05);
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1;
  min-width: 10em;
  max-width: 15em;
}
.business-image img {
  width: 100%;
}

.business-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: var(--gap);
  gap: 1.5em;
}

.business-info div span {
  margin-inline: 0.5em;
}

.business-info-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--gap);
}

.back-btn {
  position: absolute;
  left: 0;
  top: 0;
  margin: 2em;
  animation-name: playfullCallToAction;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transition: var(--transition);
}

.business-type {
  font-weight: lighter;
}

.business-desc {
  text-align: left;
  padding-inline: 2em;
}

.business-website,
.business-tel,
.business-email,
.business-schedule {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.business-website .label,
.business-tel .label,
.business-email .label,
.business-schedule .label {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap);
}

.label-icon {
  color: var(--primary-clr);
}

.data a {
  text-decoration: underline;
  transition: var(--transition);
}

.data a:hover,
.data a:focus {
  color: var(--primary-clr);
}

@media screen and (max-width: 30rem) {
  .business-website,
  .business-tel,
  .business-email,
  .business-schedule {
    flex-direction: column;
    justify-content: center;
    gap: var(--gap);
  }

  .business-website .label,
  .business-tel .label,
  .business-email .label,
  .business-schedule .label {
    justify-content: center;
  }
  .business-desc {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 46rem) {
  .call-to-action {
    flex-direction: column;
  }
}

@media screen and (max-width: 54rem) {
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5em;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

input {
  height: 2rem;
  width: inherit;
  background: white;
  color: var(--dark-clr);
  border-radius: 2rem;
  padding: 0.2rem 1rem;
  margin: 0.2rem;
  border: none;
  box-shadow: var(--box-shadow);
  font-weight: bold;
  transition: 0.5s ease;
  min-width: 17em;
  width: 50%;
  max-width: 35em;
}
</style>
